export default {
  section: 'Mis restaurantes',
  loading: 'Cargando mis restaurantes...',
  headers: {
    restaurant: 'Restaurante',
    amountAvailable: 'Saldo disponible',
    amountWithheld: 'Saldo congelado',
    initialAmount: 'Saldo inicial',
    lastAmount: 'Saldo final'
  }
}
